import store from "@/store";
import Performance from '@/components/game/scenes/Performance';
import ApplauseMeter from '@/components/game/sidebar/ApplauseMeter';

export default [
	{
		path: 'performance',
		name: "PERFORMANCE",
		components: {
			gameSpace: Performance,
			sidebar: ApplauseMeter,
		},
		props: {
			sidebar: () => ({
				rating: store.getters["game/performance/rating"],
			}),
		},
		async beforeEnter(to, from, next) {
			await store.dispatch("sound/music/fade", { volume: 0, duration: 1000 });
			await store.dispatch("game/performance/perform");
			await store.dispatch("game/scores/calculate");
			next();
		},
	},
	{
		path: 'performance/complete',
		async beforeEnter(to, from, next) {
			await store.dispatch("game/performance/complete");
			await store.dispatch("sound/music/fade", { volume: 1.0, duration: 1000 });
			next({ path: "/game/review" });
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/performance.routes.js